import React, { useMemo, useRef, useState } from "react";
import { View, StyleSheet } from "react-native";
import NtListHeader from "../../components/NtListHeader";
import NtListRow from "../../components/NtListRow";
import NtModalRingGroupDestinationsNewForm from "./NtModalRingGroupDestinationsNewForm";
import NtModalRingGroupDestinationsUpdateForm from "./NtModalRingGroupDestinationsUpdateForm";
import NtModal from "../../components/NtModal";
import ringgroupdestinationscsvcolumndata from "../data/ringgroupdestinationscsvcolumndata";
import { parseError } from "@ntconnect/framework/pbx";
import NtModalError from "../../components/NtModalError";
import NtListEmpty from "../../components/NtListEmpty";
import NtActivityIndicator from "../../components/NtActivityIndicator";
import NtModalGroupItemsAddButton from "../../components/NtModalGroupItemsAddButton";
import NtModalInputTitle from "../../components/NtModalInputTitle";
import NtListActionButton from "../../components/NtListActionButton";
import { useTheme } from "../../context/ThemeContext";

function NtModalRingGroupDestinationsField({
  title,
  containerStyle,
  destinations,
  onCreate,
  handleCreateRequest,
  onDelete,
  handleDeleteRequest,
  handleUpdateRequest,
  loading = false,
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const [deleting, setDeleting] = useState(null);
  const [error, setError] = useState(null);
  const [editingItem, setEditingItem] = useState(null);

  const newDestinationRef = useRef(null);
  const editDestinationRef = useRef(null);

  const handleDelete = async (item) => {
    if (onDelete) {
      if (handleDeleteRequest) {
        setError(null);
        setDeleting(item?.destination_number);
        const response = await handleDeleteRequest(item);
        if (response.ok) {
          onDelete(item);
        } else {
          setError(parseError(response));
        }

        setDeleting(null);
      } else {
        onDelete(item);
      }
    }
  };

  const renderAccountPickerModal = () => {
    return (
      <NtModal ref={newDestinationRef}>
        <NtModalRingGroupDestinationsNewForm
          onCancel={() => {
            newDestinationRef.current?.dismiss();
          }}
          handleCreateRequest={handleCreateRequest}
          onCreate={(params) => {
            newDestinationRef.current?.dismiss();
            if (onCreate) onCreate(params);
          }}
        />
      </NtModal>
    );
  };

  const renderEditModal = () => {
    return (
      <NtModal ref={editDestinationRef}>
        <NtModalRingGroupDestinationsUpdateForm
          item={editingItem}
          onCancel={() => editDestinationRef.current?.dismiss()}
          handleUpdateRequest={handleUpdateRequest}
          onUpdate={() => {
            editDestinationRef.current?.dismiss();
          }}
        />
      </NtModal>
    );
  };

  return (
    <View style={[styles.container, containerStyle]}>
      <NtModalInputTitle style={{ marginLeft: 4, marginBottom: 4 }}>
        {title}
      </NtModalInputTitle>

      <View style={styles.box}>
        <NtListHeader
          headerContainerStyle={{ marginRight: 35 }}
          selectedColumns={ringgroupdestinationscsvcolumndata}
        />

        <NtListEmpty
          message="No destinations"
          visible={destinations?.length == 0}
        />

        {destinations?.map((each) => (
          <NtListRow
            key={each[ringgroupdestinationscsvcolumndata[0].id]}
            item={each}
            columns={ringgroupdestinationscsvcolumndata}
            renderLeadingAction={
              handleUpdateRequest ? (
                <NtListActionButton
                  icon="pencil"
                  color={theme.brand2}
                  onPress={() => {
                    setEditingItem(each);
                    editDestinationRef.current?.show();
                  }}
                />
              ) : null
            }
            onActionIcon="delete"
            onActionColor={theme.red}
            onActionLoading={deleting == each?.destination_number}
            onActionPress={() => handleDelete(each)}
          />
        ))}

        <NtModalError error={error} containerStyle={{ marginTop: 8 }} />

        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <NtModalGroupItemsAddButton
            containerStyle={{ marginTop: 10, marginBottom: 10 }}
            title="Create new destination"
            onPress={() => newDestinationRef?.current?.show()}
          />

          {loading && (
            <NtActivityIndicator
              color={theme.brand}
              containerStyle={{ marginLeft: 10 }}
              size="small"
            />
          )}
        </View>
      </View>
      {renderAccountPickerModal()}
      {renderEditModal()}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: { marginBottom: 8 },
    box: {
      paddingHorizontal: 12,
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radius,
    },
  });

export default NtModalRingGroupDestinationsField;
